import { createAsyncThunk } from "@reduxjs/toolkit";
import { API_URL } from "../../../app/config";
import { axiosApiInstance } from "../../../app/axios";
import { ErrorToast, SuccessToast } from "../../../components/toast/Toasts";
import { IPromoCode } from "../promocodeModel";
import moment from "moment";

export const getAllPromoCodes = createAsyncThunk(
  "PromoCode/FindAllPromoCode",
  async () => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/PromoCode/FindAllPromoCode`,
        {
          Limit: 100,
          Skip: 0,
          PromoCode: "",
          FromDate: "",
          ToDate: "",
        }
      );
      return response.data?.Data;
    } catch (error: any) {
      console.error("Error Fetching PromoCodes:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const createPromoCode = createAsyncThunk(
  "PromoCode/InsertPromoCode",
  async (formData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/PromoCode/InsertPromoCode`,
        formData
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error Fetching PromoCodes:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const updatePromoCode = createAsyncThunk(
  "PromoCode/UpdatePromoCode",
  async (formData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/PromoCode/UpdatePromoCode`,
        formData
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error updating PromoCode:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const getPromoCodeById = createAsyncThunk(
  "PromoCode/FindByIDPromoCode",
  async (ID: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/PromoCode/FindByIDPromoCode`,
        { ID: ID }
      );
      const result = response.data?.Data as any;
      return {
        ID: result.ID,
        PromoCode: result.PromoCode,
        FromDate: result.FromDate ? moment(result.FromDate, "").toDate() : "",
        ToDate: result.ToDate ? moment(result.ToDate).toDate() : "",
        DiscountType: result.DiscountType,
        Value: result.Value,
        MaxDiscount: result.MaxDiscount,
        ApplyOn: result.ApplyOn,
        IsActive: result.IsActive ? 1 : 2,
      } as IPromoCode;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error Fetching PromoCodes:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const generatePromoCode = createAsyncThunk(
  "PromoCode/GeneratePromoCode",
  async () => {
    try {
      const response = await axiosApiInstance.get(
        `${API_URL}/PromoCode/GeneratePromoCode`
      );
      return response.data?.Data?.PromoCode || "";
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error Fetching PromoCodes:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const deletePromoCode = createAsyncThunk(
  "PromoCode/DeletePromoCode",
  async (ID: number) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/PromoCode/DeletePromoCode`,
        { ID: ID }
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error Deleting PromoCode:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const findAllActivePromoCode = createAsyncThunk(
  "PromoCode/FindAllActivePromoCode",
  async () => {
    try {
      const response = await axiosApiInstance.get(
        `${API_URL}/PromoCode/FindAllActivePromoCode`
      );
      // SuccessToast(response.data?.Details || "Success");
      return response.data.Data;
    } catch (error: any) {
      console.error("Error Deleting PromoCodes:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const promocodeActiveInactive = createAsyncThunk(
  "PromoCode/ActiveInActivePromoCode",
  async (formData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/PromoCode/ActiveInActivePromoCode`,
        formData
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error active-inactive PromoCode:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);
